import { makeStyles } from '@material-ui/core/styles';

type AvatarProps = {
  initial: string | undefined;
  onClick: (event: unknown) => void;
};

const useStyles = makeStyles((theme) => ({
  avatar: {
    width: '45px',
    height: '45px',
    borderRadius: '50%',
    border: 'none',
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    cursor: 'pointer',
  },
}));

export const Avatar: React.FC<AvatarProps> = ({ initial, onClick }) => {
  const classes = useStyles();
  return (
    <button className={classes.avatar} onClick={onClick}>
      <strong>{initial}</strong>
    </button>
  );
};
